<!-- Modal Header -->
<div class="modal-header">
  <div class="header-content">
    <div class="file-title">
      <i class="fa fa-file-alt"></i>
      <h4 class="modal-title">{{ fileInfo?.name }}</h4>
    </div>

    <div class="header-actions">
      <!-- Index Button -->
      <button type="button" class="action-btn action-btn-outline"
              (click)="indexDocument()"
              [disabled]="fileInfo?.status === 'Indexing'"
              title="Split document into chunks and index for search">
        <i *ngIf="fileInfo?.status === 'Indexing'" class="fa fa-spinner fa-spin"></i>
        <i *ngIf="fileInfo?.status !== 'Indexing'" class="fa fa-layer-group"></i>
        <span>{{ fileInfo?.status === 'Indexing' ? 'Indexing...' : 'Index Document' }}</span>
      </button>

      <button type="button" class="btn-close-custom" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body-wrapper">
  <div class="modal-body-content">
    <div class="document-viewer">

      <!-- Agent source banner (only when highlight is present) -->
      <div class="info-banner" *ngIf="mappedSnippetsForHighlighter.length > 0">
        <div class="banner-content">
          <i class="fa fa-bullseye"></i>
          <span>AI source highlighted in the document</span>
        </div>
      </div>

      <!-- Document Content -->
      <div class="document-content-wrapper">
        <!-- With highlights (from agent source) -->
        <app-document-highlighter
          *ngIf="fileInfo?.content && mappedSnippetsForHighlighter.length > 0"
          [textContent]="fileInfo.content"
          [highlights]="mappedSnippetsForHighlighter"
          [allowManualHighlighting]="false">
        </app-document-highlighter>

        <!-- Plain text (no highlights) -->
        <div *ngIf="fileInfo?.content && mappedSnippetsForHighlighter.length === 0"
             class="plain-text-content">
          {{ fileInfo.content }}
        </div>

        <div *ngIf="!fileInfo?.content" class="empty-state">
          <i class="fa fa-file-alt"></i>
          <p>Content not available</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Footer -->
<div class="modal-footer-custom">
  <div class="footer-info"></div>
  <div class="footer-actions">
    <button type="button" class="footer-btn footer-btn-secondary" (click)="activeModal.close('Close click')">
      Close
    </button>
  </div>
</div>
